// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
//import App from './App';

import MCPage from './MCPage';

//import DynamicForm from './DynamicForm'
import { router } from './router'

import VueMask from 'v-mask'
import Vuelidate from 'vuelidate';
import Vuex from 'vuex';


// bootstrap vue components
import { BootstrapVue } from 'bootstrap-vue';
import vuetify from '@/plugins/vuetify';
import LoanParams from '@/plugins/loan-params';
import Toasted from 'vue-toasted';

import { getCurrentBrowserFingerPrint } from "@rajesh896/broprint.js";



// message bus
export const bus = new Vue();    



import common from '@/mixins/common';
Vue.mixin(common);

Vue.use(LoanParams);
Vue.use(VueMask);
Vue.use(Vuelidate);
Vue.use(Vuex);
Vue.use(BootstrapVue);
Vue.use(Toasted);


// uuid generator
window.uuidv4 = function() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                              1117459144040421
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}


window.__sid = window.uuidv4();




window.onbeforeunload = function(event) {


  // main vue reference - APP
  window.APP && window.APP.log(' - PAGE RELOAD -');


  // on debug mode no popup
/*  if (window.APP && window.APP.getConf('debug') == 'on') {
    return false;
  }


  return "Czy na pewno chcesz opuścić składanie wniosku?";*/

};


window.onerror = function(msg, src, line_nbr) {


  // main vue reference - APP
  window.APP && window.APP.log(' - JS ERROR -', msg, src, line_nbr);



};




getCurrentBrowserFingerPrint().then((fingerprint) => {
    // fingerprint is your unique browser id.
    // This is well tested

  //console.log('fingerprint ', fingerprint);


    window.fingerprint = fingerprint;

    // the result you receive here is the combination of Canvas fingerprint and audio fingerprint.
});


const store = new Vuex.Store({
  user: {
    firstName: '',
    lastName: '',
    email: '',
    telephone: '',
    website: ''
  }
});


Vue.config.productionTip = false;

// transactionlink
Vue.config.ignoredElements = [
  't10l-widget',
  'transactionlink-widget'
];


/* eslint-disable no-new */
let app =  new Vue({
  store: store,


  router,
  vuetify,


  computed: {

    mainpage() {

      return this.$children[0];
    }
  },



  methods: {


  

  },


  render: h => h( MCPage ),
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js